"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAutoOverflow = exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _debounce = require("./debounce");
var _useResizeObserver = require("./useResizeObserver");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const useAutoOverflow = ({
  disable,
  targetRef,
  children,
  overflowElement,
  overflowPadding = 0,
  itemGap,
  overflowFromStart,
  overflownProps,
  debounceDelay,
  orientation = 'horizontal',
  observedDimension
}) => {
  const childrenCount = _react.default.Children.count(children);
  const [overflowIndex, setOverflowIndex] = (0, _react.useState)(overflowFromStart ? 0 : childrenCount);
  const childRefs = (0, _react.useRef)([]);
  const overflowElementRef = (0, _react.useRef)();
  const offsetDimension = orientation === 'vertical' ? 'offsetHeight' : 'offsetWidth';
  const isItemAllowedToOverflow = index => {
    var _a;
    return childRefs.current[index] && !((_a = childRefs.current[index]) === null || _a === void 0 ? void 0 : _a.getAttribute('data-no-overflow'));
  };
  const getTargetStyles = () => {
    var _a;
    if (!(targetRef === null || targetRef === void 0 ? void 0 : targetRef.current)) return {};
    const styles = ((_a = window === null || window === void 0 ? void 0 : window.getComputedStyle) === null || _a === void 0 ? void 0 : _a.call(window, targetRef.current)) || {};
    const padding = orientation === 'horizontal' ? parseInt(styles === null || styles === void 0 ? void 0 : styles['padding-left'], 10) + parseInt(styles === null || styles === void 0 ? void 0 : styles['padding-right'], 10) : parseInt(styles === null || styles === void 0 ? void 0 : styles['padding-top'], 10) + parseInt(styles === null || styles === void 0 ? void 0 : styles['padding-bottom'], 10);
    const gap = parseInt(styles === null || styles === void 0 ? void 0 : styles['column-gap'], 10);
    return {
      padding: Number.isNaN(padding) ? 0 : padding,
      gap: Number.isNaN(gap) ? 0 : gap
    };
  };
  const markOverflowItems = (containerDimension = 0) => {
    var _a, _b, _c, _d;
    const targetStyles = getTargetStyles();
    // go through items not allowed to be overflown to figure out
    // a fixed amount of space
    let fixedAmountUsed = (_a = targetStyles.padding) !== null && _a !== void 0 ? _a : 0;
    const gap = itemGap || targetStyles.gap || 0;
    for (let i = 0; i < (((_b = childRefs.current) === null || _b === void 0 ? void 0 : _b.length) || 0); i += 1) {
      if (!isItemAllowedToOverflow(i)) {
        const item = childRefs.current[i];
        const itemDimension = ((item === null || item === void 0 ? void 0 : item[offsetDimension]) || 0) + gap;
        fixedAmountUsed += itemDimension;
      }
    }
    const availableContainerDimension = containerDimension - (overflowElementRef.current ? overflowElementRef.current[offsetDimension] + gap : 0) - overflowPadding - fixedAmountUsed;
    let idx;
    let amountUsed = 0;
    if (overflowFromStart) {
      for (idx = (((_c = childRefs.current) === null || _c === void 0 ? void 0 : _c.length) || 0) - 1; idx >= 0; idx -= 1) {
        if (isItemAllowedToOverflow(idx)) {
          const item = childRefs.current[idx];
          const itemDimension = ((item === null || item === void 0 ? void 0 : item[offsetDimension]) || 0) + gap;
          amountUsed += itemDimension;
          if (amountUsed > availableContainerDimension) {
            idx += 1;
            break;
          }
        }
      }
    } else {
      // from end
      for (idx = 0; idx < (((_d = childRefs.current) === null || _d === void 0 ? void 0 : _d.length) || 0); idx += 1) {
        if (isItemAllowedToOverflow(idx)) {
          const item = childRefs.current[idx];
          const itemDimension = ((item === null || item === void 0 ? void 0 : item[offsetDimension]) || 0) + gap;
          amountUsed += itemDimension;
          if (amountUsed > availableContainerDimension) {
            break;
          }
        }
      }
    }
    setOverflowIndex(idx);
  };
  const handleResize = (0, _debounce.debounce)(({
    width,
    height
  }) => {
    markOverflowItems(orientation === 'horizontal' ? width : height);
  }, debounceDelay);
  (0, _react.useEffect)(() => {
    var _a, _b;
    if (disable || !targetRef.current) return;
    handleResize({
      width: (_a = targetRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth,
      height: (_b = targetRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight
    });
  }, [children]);
  (0, _react.useEffect)(() => {
    if (childrenCount < childRefs.current.length) {
      childRefs.current = childRefs.current.slice(0, childrenCount);
    }
  }, [childrenCount]);
  (0, _useResizeObserver.useResizeObserver)({
    targetRef,
    onResize: handleResize,
    disconnect: disable,
    skipStateUpdate: true,
    observedDimension
  });
  const isItemOverflown = index => overflowFromStart ? index < overflowIndex : index >= overflowIndex;
  const getBaseChildrenToRender = () => _react.default.Children.map(children, (child, index) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const isOverflown = isItemAllowedToOverflow(index) && isItemOverflown(index);
    const overflownStyle = {
      position: 'absolute',
      visibility: 'hidden',
      top: -1000,
      left: -1000
    };
    const autoOverflowProps = {
      style: isOverflown ? Object.assign(Object.assign({}, (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.style), overflownStyle) : (_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.style,
      'data-is-overflown': isOverflown ? true : undefined,
      'aria-hidden': isOverflown ? true : undefined
    };
    const consumerProps = overflownProps === null || overflownProps === void 0 ? void 0 : overflownProps(child, autoOverflowProps);
    const referElement = element => {
      childRefs.current[index] = element;
    };
    let refProps = {
      ref: (0, _reactMergeRefs.default)([child === null || child === void 0 ? void 0 : child.ref, referElement])
    };
    const hasTarget = ((_c = child === null || child === void 0 ? void 0 : child.type) === null || _c === void 0 ? void 0 : _c.displayName) === 'Tooltip' || ((_d = child === null || child === void 0 ? void 0 : child.type) === null || _d === void 0 ? void 0 : _d.displayName) === 'Overlay' || ((_e = child === null || child === void 0 ? void 0 : child.type) === null || _e === void 0 ? void 0 : _e.displayName) === 'BulkActionHelperPopover' || ((_f = child === null || child === void 0 ? void 0 : child.type) === null || _f === void 0 ? void 0 : _f.displayName) === 'MessageListPopover';
    if (hasTarget) {
      // if the current child is a component that wraps a rendered target
      // like a tooltip, or overlay, we need to refer to the target for overflow
      // calculations hence we use attach the ref to targetProps.
      refProps = {
        targetProps: Object.assign(Object.assign(Object.assign({}, (_g = child === null || child === void 0 ? void 0 : child.props) === null || _g === void 0 ? void 0 : _g.targetProps), consumerProps === null || consumerProps === void 0 ? void 0 : consumerProps.targetProps), {
          ref: (0, _reactMergeRefs.default)([(_j = (_h = child === null || child === void 0 ? void 0 : child.props) === null || _h === void 0 ? void 0 : _h.targetProps) === null || _j === void 0 ? void 0 : _j.ref, referElement])
        })
      };
    }
    const extendedProps = Object.assign(Object.assign(Object.assign({}, autoOverflowProps), consumerProps), refProps);
    return /*#__PURE__*/_react.default.cloneElement(child, extendedProps);
  });
  const getChildrenToRender = () => {
    if (overflowElement) {
      return [...getBaseChildrenToRender(), /*#__PURE__*/_react.default.cloneElement(overflowElement, {
        'aria-hidden': true,
        key: 'overflow-element-placeholder',
        ref: (0, _reactMergeRefs.default)([overflowElement === null || overflowElement === void 0 ? void 0 : overflowElement.ref, overflowElementRef]),
        style: {
          position: 'absolute',
          visibility: 'hidden',
          top: -1000,
          left: -1000
        }
      })];
    }
    return getBaseChildrenToRender();
  };
  const overflowChildrenToRender = [];
  if (!disable) {
    _react.default.Children.forEach(children, (child, index) => {
      if (isItemAllowedToOverflow(index) && isItemOverflown(index)) {
        overflowChildrenToRender.push(child);
      }
    });
  }
  return disable ? {} : {
    overflowIndex,
    handleResize,
    isOverflowing: overflowChildrenToRender.length > 0,
    childrenToRender: getChildrenToRender(),
    overflowChildrenToRender
  };
};
exports.useAutoOverflow = useAutoOverflow;
var _default = exports.default = useAutoOverflow;